import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    calloutContent:
      'On average, our users get paid 3 to 4 times faster by credit card.',
    calloutTitle: 'Did you know?',
    creditCard: 'Credit card',
    creditCardFeesInsideEU: '{0} fees for payments inside EU',
    creditCardFeesOutsideEU: '{0} fees for payments outside EU',
    creditCardHighlight: 'The fastest',
    creditCardNotAllowed: 'Available for invoices lower than €{0}',
  },
  fr: {
    calloutContent:
      'En moyenne, nos utilisateur·ices se font payer 3 à 4 fois plus vite par carte bancaire.',
    calloutTitle: 'Le saviez-vous\xa0?',
    creditCard: 'Carte bancaire',
    creditCardFeesInsideEU: 'Commission de {0} pour les paiements dans l’UE',
    creditCardFeesOutsideEU: 'Commission de {0} pour les paiements hors UE',
    creditCardHighlight: 'Le plus rapide',
    creditCardNotAllowed:
      'Disponible pour les factures d’un montant inférieur à {0}\xA0€',
  },
} as const);

export default locales;
